import React, { useMemo } from 'react';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import ContentAccordion from 'libraries/ContentAccordion';
import StrengthIcon from './strengthIcon.svg';
import ImproveIcon from './improveIcon.svg';
import QuestionIcon from './question.svg';
import useStyles from './styles';

const SummaryBlock = ({
    user
}) => {
    const classes = useStyles();

    if (!user || !user.candidateAiSummary) return null;

    const { candidateAiSummary, score } = user;

    const strengthList = useMemo(() => candidateAiSummary.points.filter(el => el.type === 'strength'), [candidateAiSummary]);
    const improveList = useMemo(() => candidateAiSummary.points.filter(el => el.type === 'improve'), [candidateAiSummary]);

    const hideAreasOfStrength = score?.score <= 20;
    const hideAreasOfImprovements = score?.score === 100;

    return (
        <div className={clsx(classes.wrapper)}>
            <Typography variant="h5">Summary</Typography>
            {
                candidateAiSummary.text && (
                    <p className={classes.text}>
                        {candidateAiSummary.text}
                    </p>
                )
            }
            {
                candidateAiSummary.points.length > 0 && (
                    <div className={classes.areasBlock}>
                        {
                            !hideAreasOfStrength && (
                                <div className={clsx('block', (!hideAreasOfImprovements && !hideAreasOfStrength) && 'equal')}>
                                    <div className="title">
                                        <img src={StrengthIcon} alt="" />
                                        Areas of Strength
                                    </div>
                                    <div className="points">
                                        <ul>
                                            {
                                                strengthList.map(el => (
                                                    <li>
                                                        <strong>{el.title}</strong>
                                                        <p>{el.text}</p>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                        {
                            !hideAreasOfImprovements && (
                                <div className={clsx('block', (!hideAreasOfImprovements && !hideAreasOfStrength) && 'equal')}>
                                    <div className="title">
                                        <img src={ImproveIcon} alt="" />
                                        Areas of Improvement
                                    </div>
                                    <div className="points">
                                        <ul>
                                            {
                                                improveList.map(el => (
                                                    <li>
                                                        <strong>{el.title}</strong>
                                                        <p>{el.text}</p>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
            {
                candidateAiSummary.questions.length > 0 && (
                    <div className="u-mrg--tx5">
                        <ContentAccordion
                            className={classes.accordion}
                            header={(
                                <Typography className="u-mrg--bx2">
                                    <div className="u-dsp--f u-ai--center">
                                        <img src={QuestionIcon} alt="" />
                                Potential Follow-up Interview Questions
                                    </div>
                                </Typography>
                            )}
                            content={(
                                <ol className={classes.questions}>
                                    {candidateAiSummary.questions.map(el => (
                                        <li key={el.id}>
                                            <strong>{el.title}</strong>
                                            <p>{el.text}</p>
                                        </li>
                                    ))}
                                </ol>
                            )}
                        />
                    </div>
                )
            }
        </div>
    );
};

export default SummaryBlock;
